import styled from 'styled-components';
import { colors } from '../../../../theme/style-helpers';
import CheckmarkIconOrange from '../../../../assets/icons/checkmark_icon_orange.svg';

export const Container = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.BLACK};
  margin-bottom: 16px;
`;

export const ScrollBox = styled.div`
  border: 1px solid ${colors.COOL_GREY};
  border-radius: 4px;
  padding: 16px;
  max-height: 300px;
  overflow-y: auto;
  background-color: ${colors.WHITE};
  margin-bottom: 16px;

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: ${colors.LIGHT_GREY};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${colors.COOL_GREY};
    border-radius: 4px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: ${colors.BRAND_ORANGE};
  }
`;

export const TermsContent = styled.div`
  font-size: 14px;
  line-height: 1.6;
  color: ${colors.BLACK};

  h4 {
    font-size: 14px;
    font-weight: 700;
    margin-top: 16px;
    margin-bottom: 8px;
  }

  p {
    margin-bottom: 12px;
  }

  strong {
    font-weight: 700;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
`;

export const CheckboxLabel = styled.label`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  cursor: pointer;
  user-select: none;
`;

export const CheckboxInput = styled.input`
  cursor: pointer;
  appearance: none;
  width: 20px;
  height: 20px;
  min-width: 20px;
  border: 1px solid #63666A;
  box-sizing: border-box;
  border-radius: 2px;
  background-color: ${colors.WHITE};
  margin-top: 2px;

  &:checked {
    background-position: center center;
    background-repeat: no-repeat;
    background-image: url(${CheckmarkIconOrange});
    border-color: ${colors.BRAND_ORANGE};
    border-width: 2px;
  }

  &:focus {
    outline: #FFDFD0 solid 3px;
  }

  &:hover {
    outline: #FFDFD0 solid 3px;
  }
`;

export const CheckboxText = styled.span`
  font-size: 14px;
  line-height: 1.5;
  color: ${colors.BLACK};

  a {
    color: ${colors.BRAND_ORANGE};
    text-decoration: underline;

    &:hover {
      color: ${colors.DARK_ORANGE};
    }
  }
`;

export const RequiredLabel = styled.span`
  font-size: 16px;
  font-weight: 700;
  color: ${colors.BLACK};
  margin-bottom: 8px;
  display: block;

  &::after {
    content: '*';
    color: ${colors.BRAND_ORANGE};
    margin-left: 2px;
  }
`;

export const ErrorMessage = styled.span`
  color: ${colors.RED};
  font-size: 12px;
  margin-top: 4px;
  display: block;
`;
